import {useQuery} from "@tanstack/react-query";
import {getCurrentUser, type User} from "@/lib/users-api";

const CURRENT_USER_KEY = "currentUser";

/**
 * Hook to fetch the current authenticated user's profile
 */
export function useCurrentUser() {
  return useQuery<User>({
    queryKey: [CURRENT_USER_KEY],
    queryFn: getCurrentUser,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 30 * 60 * 1000, // 30 minutes
  });
}
